import React from 'react'
import date from '@/utils/date'
import { Link } from 'gatsby'
import * as css from './NewsItem.module.css'

const NewsItem = ({ title, publishDate, metaInfo }) => (
	<li className={`${css.root} mb-4 richtext-sm`}>
		<h3>
			<Link className="h3 text-orange hover:underline" to={`/blog/${ metaInfo.slug.current }`}>
				{title}
			</Link>
		</h3>
		<p>
			<time dateTime={publishDate}>
				{date(publishDate)}
			</time>
		</p>
	</li>
)

export default NewsItem
